import { LayaGL } from "../../../layagl/LayaGL";
import { Matrix } from "../../../maths/Matrix";
import { Vector3 } from "../../../maths/Vector3";
import { BaseRenderNode2D } from "../../../NodeRender2D/BaseRenderNode2D";
import { Mesh2DRender } from "../Mesh2DRender";
import { Command2D } from "./Command2D";
export class DrawMesh2DCMD extends Command2D {
    static create(mesh, mat, texture, color, material) {
        var cmd = DrawMesh2DCMD._pool.length > 0 ? DrawMesh2DCMD._pool.pop() : new DrawMesh2DCMD();
        cmd.mesh = mesh;
        cmd.material = material;
        cmd.texture = texture;
        cmd.color = color;
        cmd._setMatrix(mat);
        return cmd;
    }
    constructor() {
        super();
        this._drawElementData = LayaGL.render2DRenderPassFactory.createDraw2DElementCMDData();
        this._mesh2DRender = new Mesh2DRender();
        this._needUpdateElement = true;
        this._matrix = new Matrix();
    }
    _setMatrix(value) {
        value ? value.copyTo(this._matrix) : Matrix.EMPTY.copyTo(this._matrix);
        let mat = this._matrix;
        let vec3 = Vector3.TEMP;
        vec3.x = mat.a;
        vec3.y = mat.c;
        vec3.z = mat.tx;
        this._mesh2DRender._spriteShaderData.setVector3(BaseRenderNode2D.NMATRIX_0, vec3);
        vec3.x = mat.b;
        vec3.y = mat.d;
        vec3.z = mat.ty;
        this._mesh2DRender._spriteShaderData.setVector3(BaseRenderNode2D.NMATRIX_1, vec3);
    }
    set material(value) {
        if (value == this.material)
            return;
        if (!value)
            value = Mesh2DRender.mesh2DDefaultMaterial;
        this._mesh2DRender.sharedMaterial = value;
        this._needUpdateElement = true;
    }
    get material() {
        return this._mesh2DRender.sharedMaterial;
    }
    set mesh(value) {
        if (value == this.mesh)
            return;
        this._mesh2DRender.sharedMesh = value;
        this._needUpdateElement = true;
    }
    get mesh() {
        return this._mesh2DRender.sharedMesh;
    }
    set texture(value) {
        this._mesh2DRender.texture = value;
    }
    get texture() {
        return this._mesh2DRender.texture;
    }
    set color(value) {
        this._mesh2DRender.color = value;
        let a = value.a;
        let renderColor = this._mesh2DRender._setRenderColor;
        renderColor.setValue(value.r * a, value.g * a, value.b * a, a);
        this._mesh2DRender._spriteShaderData.setColor(BaseRenderNode2D.BASERENDER2DCOLOR, renderColor);
    }
    get color() {
        return this._mesh2DRender.color;
    }
    getRenderCMD() {
        return this._drawElementData;
    }
    run() {
        if (this._needUpdateElement) {
            this._drawElementData.setRenderelements(this._mesh2DRender._renderElements);
            this._needUpdateElement = false;
        }
        this._mesh2DRender._setRenderSize(this._commandBuffer._renderSize.x, this._commandBuffer._renderSize.y);
    }
    recover() {
        DrawMesh2DCMD._pool.push(this);
        super.recover();
        this.material = null;
        this.texture = null;
        this.mesh = null;
    }
    destroy() {
        super.destroy();
        this.material = null;
    }
}
DrawMesh2DCMD._pool = [];
